import React, { useEffect, useMemo, useState } from 'react'
import { MdFilterAlt, MdFilterAltOff, MdLayers , MdLayersClear   } from "react-icons/md";

const formatRelative = (timestamp) => {
  if (!timestamp) return 'No saves yet'
  const value = typeof timestamp === 'string' ? new Date(timestamp) : timestamp
  if (Number.isNaN(value?.getTime?.())) return 'Save time unavailable'

  const diffMs = Date.now() - value.getTime()
  if (diffMs < 60_000) return 'Saved just now'

  const diffMinutes = Math.floor(diffMs / 60_000)
  if (diffMinutes < 60) {
    return `Saved ${diffMinutes} minute${diffMinutes === 1 ? '' : 's'} ago`
  }

  const diffHours = Math.floor(diffMinutes / 60)
  if (diffHours < 24) {
    return `Saved ${diffHours} hour${diffHours === 1 ? '' : 's'} ago`
  }

  const diffDays = Math.floor(diffHours / 24)
  return `Saved ${diffDays} day${diffDays === 1 ? '' : 's'} ago`
}

const SelectionToolbar = ({
  selectedCount,
  onSave,
  onReset,
  lastSavedAt,
  referenceVisible,
  filtersVisible,
  onToggleFilters,
  onToggleReference
}) => {
  const disabled = selectedCount === 0
  const [tick, setTick] = useState(Date.now())

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setTick(Date.now())
    }, 30_000)

    return () => {
      window.clearInterval(intervalId)
    }
  }, [])

  const lastSavedMessage = useMemo(() => {
    void tick
    return formatRelative(lastSavedAt)
  }, [lastSavedAt, tick])

  return (
    <section className="flex flex-col gap-3 rounded-2xl border border-customAccent/20 bg-white/90 p-4 shadow-lg shadow-customAccent/10 backdrop-blur-sm dark:border-customMuted/30 dark:bg-customSurface/80 dark:shadow-customSurface">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        {/* <div>
          <p className="text-sm font-semibold uppercase tracking-wide text-customAccent dark:text-customLightYellow">
            Selected events
          </p>
          <p className="text-lg font-medium text-customInk dark:text-customHeading">
            {selectedCount} {selectedCount === 1 ? 'event' : 'events'} ready to manage
          </p>
        </div> */}
        <div>
          <h1 className="text-2xl font-semibold text-customInk dark:text-customHeading">League selection</h1>
          <p className="text-sm text-customSecondaryText dark:text-customMuted">
            Curate leagues and events with quick filters and smart selection tools.
          </p>
          <p className="text-sm font-semibold text-customFontGreen dark:text-customHeading flex gap-2 items-center">
             <span className="inline-flex h-2 w-2 rounded-full bg-customFontGreen" />
            Event selected {selectedCount} {selectedCount === 1 ? 'event' : 'events'} ready to manage
          </p>
        </div>
        <div className="flex flex-col items-start gap-2 sm:items-end">
          <div className="flex items-center gap-2 rounded-xl border border-customAccent/30 bg-customAccent/5 px-3 py-2 text-xs font-medium text-customAccent dark:border-customAccent/40 dark:bg-customAccent/10 dark:text-customHeading">
            <span className="inline-flex h-2 w-2 rounded-full bg-customAccent" />
            {lastSavedMessage}
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <button
              type="button"
              onClick={onToggleFilters}
              className="inline-flex items-center gap-2 rounded-xl border border-customAccentBlue/30 bg-customAccentBlue/5 px-4 py-2 text-sm font-semibold text-customAccentBlue transition hover:bg-customAccentBlue/10 focus:outline-none focus:ring-2 focus:ring-customAccentBlue/30 dark:border-customAccent/40 dark:bg-customAccent/10 dark:text-customHeading"
            >
              {filtersVisible ? <MdFilterAltOff size={16} /> : <MdFilterAlt size={16} />}
              {filtersVisible ? 'Hide Advanced Filters' : 'Show Advanced Filters'}
            </button>
              <button
              type="button"
              onClick={onToggleReference}
              className="inline-flex items-center gap-2 rounded-xl border border-customAccentBlue/30 bg-customAccentBlue/5 px-4 py-2 text-sm font-semibold text-customAccentBlue transition hover:bg-customAccentBlue/10 focus:outline-none focus:ring-2 focus:ring-customAccentBlue/30 dark:border-customAccent/40 dark:bg-customAccent/10 dark:text-customHeading"
            >
              {referenceVisible ? <MdLayersClear size={16} /> : <MdLayers size={16} />}
              {referenceVisible ? 'Hide Reference' : 'Show Reference'}
            </button>
            <button
              type="button"
              className="rounded-xl border border-customAccent/40 px-4 py-2 text-sm font-semibold text-customAccent transition hover:bg-customAccent/10 dark:border-customAccent/40 dark:text-customHeading dark:hover:bg-customAccent/10"
              onClick={onReset}
            >
              Reset
            </button>
            <button
              type="button"
              onClick={onSave}
              disabled={disabled}
              className={`rounded-xl px-4 py-2 text-sm font-semibold shadow-lg transition focus:outline-none focus:ring-2 focus:ring-customAccent focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60 ${
                disabled
                  ? 'bg-customAccent/40 text-white'
                  : 'bg-customAccentBlue text-white hover:from-customAccentBlue hover:to-customAccent'
              }`}
            >
              Save selections
            </button>
          </div>
        </div>
      </div>
      {/* <div className="grid gap-2 text-xs text-customSecondaryText dark:text-customMuted sm:grid-cols-2">
        <div className="flex items-center gap-2">
          <span className="inline-flex h-2 w-2 rounded-full bg-customAccentBlue" />
          Single selections unlock confidence controls.
        </div>
        <div className="flex items-center gap-2">
          <span className="inline-flex h-2 w-2 rounded-full bg-customVibrantGreen" />
          Parlay selections group automatically at export.
        </div>
      </div> */}
    </section>
  )
}

export default SelectionToolbar
